import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useUpdateInventoryLocationMutation } from '../../../../graphql'
import { InventoryLocation } from 'inventory-web'

export default function useUpdateInventoryLocationHandler( updateAfterEdit?: ( updatedInventoryLocation: InventoryLocation ) => void ) {
	const [ updateStore ] = useUpdateInventoryLocationMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( inventoryLocationId: number, branchId?: number, name?: string ) => {
		const result = await updateStore( { variables: {
			inventoryLocationId,
			branchId,
			name,
		} } )

		if ( updateAfterEdit && result.data?.updateInventoryLocation?.inventoryLocation ) {
			updateAfterEdit( result.data.updateInventoryLocation.inventoryLocation )
		}

		if ( result.data?.updateInventoryLocation?.success ) {
			showSuccess( `updateInventoryLocationSuccess${Date.now()}`, result.data?.updateInventoryLocation?.message ?? 'Successfully updated store!' )
		} else {
			showError( `updateInventoryLocationError${Date.now()}`, result.data?.updateInventoryLocation?.message ?? 'Sorry, an error occurred' )
		}
	}
}
